import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  loading: false,
  error: null,
  package: null,
};

const packageDetailsSlice = createSlice({
  name: "packageDetails",
  initialState,
  reducers: {
    fetchPackage(state, action) {
      state.loading = true;
    },
    fetchPackageSuccess(state, action) {
      state.package = action.payload.data.document;
      state.loading = false;
    },
    fetchPackageFailure(state, action) {
      state.loading = false;
    },
  },
});

export const { actions, reducer, name: sliceKey } = packageDetailsSlice;
